// Static option lists + tab definitions for the simulator settings module.
// Numeric values mirror the backend enums (Newtonsoft serializes enums as numbers):
//   InsuranceStartDate: Today = 1, FirstInTheMonth = 2
//   YesNo:              Yes   = 0, No              = 1

export type SettingsTabKey =
    | 'general'
    | 'companies'
    | 'discounts'
    | 'roadServices'
    | 'commissions';

export interface SettingsTab {
    key: SettingsTabKey;
    label: string;
    /** false while the tab is still a placeholder (built in a later slice). */
    ready: boolean;
}

export const SETTINGS_TABS: SettingsTab[] = [
    { key: 'general', label: 'כללי', ready: true },
    { key: 'companies', label: 'חברות', ready: true },
    { key: 'discounts', label: 'הנחות', ready: true },
    { key: 'roadServices', label: 'שירותי דרך', ready: false },
    { key: 'commissions', label: 'עמלות', ready: false },
];

export interface SelectOption {
    value: number | string; // '' represents a null/"all" choice
    label: string;
}

export const INSURANCE_START_DATE_OPTIONS: SelectOption[] = [
    { value: 1, label: 'היום' },
    { value: 2, label: 'ה-1 לחודש העוקב' },
];

export const YES_NO_OPTIONS: SelectOption[] = [
    { value: 0, label: 'כן' },
    { value: 1, label: 'לא' },
];
